const _temp0 = require("url:./absorber.png");
const _temp1 = require("url:./absorber_charge.png");
const _temp2 = require("url:./basic_projector.png");
const _temp3 = require("url:./battery.png");
const _temp4 = require("url:./blank.png");
const _temp5 = require("url:./border.png");
const _temp6 = require("url:./colonists1.png");
const _temp7 = require("url:./colonists2.png");
const _temp8 = require("url:./colonists3.png");
const _temp9 = require("url:./cursor_build.png");
const _temp10 = require("url:./cursor_cancel.png");
const _temp11 = require("url:./cursor_move.png");
const _temp12 = require("url:./cursor_reflector.png");
const _temp13 = require("url:./direction-indicator.png");
const _temp14 = require("url:./disabled.png");
const _temp15 = require("url:./enemy_armored_1.png");
const _temp16 = require("url:./enemy_armored_2.png");
const _temp17 = require("url:./enemy_burrowed_1.png");
const _temp18 = require("url:./enemy_burrowed_2.png");
const _temp19 = require("url:./enemy_burrower_1.png");
const _temp20 = require("url:./enemy_burrower_2.png");
const _temp21 = require("url:./enemy_drone_1.png");
const _temp22 = require("url:./enemy_drone_2.png");
const _temp23 = require("url:./enemy_flyer_1.png");
const _temp24 = require("url:./enemy_flyer_2.png");
const _temp25 = require("url:./enemy_volatile_1.png");
const _temp26 = require("url:./enemy_volatile_2.png");
const _temp27 = require("url:./exclamation_double.png");
const _temp28 = require("url:./exclamation_single.png");
const _temp29 = require("url:./exclamation_triple.png");
const _temp30 = require("url:./factory.png");
const _temp31 = require("url:./farm.png");
const _temp32 = require("url:./farm_growth_1.png");
const _temp33 = require("url:./farm_growth_2.png");
const _temp34 = require("url:./farm_growth_3.png");
const _temp35 = require("url:./fertile.png");
const _temp36 = require("url:./floor.png");
const _temp37 = require("url:./food.png");
const _temp38 = require("url:./laser.png");
const _temp39 = require("url:./laser_4split.png");
const _temp40 = require("url:./laser_burst.png");
const _temp41 = require("url:./laser_player_down.png");
const _temp42 = require("url:./laser_player_left.png");
const _temp43 = require("url:./laser_player_right.png");
const _temp44 = require("url:./laser_player_up.png");
const _temp45 = require("url:./laser_reflected.png");
const _temp46 = require("url:./laser_split.png");
const _temp47 = require("url:./machinery.png");
const _temp48 = require("url:./metal.png");
const _temp49 = require("url:./mine.png");
const _temp50 = require("url:./mining_spot.png");
const _temp51 = require("url:./mountain.png");
const _temp52 = require("url:./ore.png");
const _temp53 = require("url:./outline_dashed.png");
const _temp54 = require("url:./outline_exclamation.png");
const _temp55 = require("url:./outline_solid.png");
const _temp56 = require("url:./player.png");
const _temp57 = require("url:./power.png");
const _temp58 = require("url:./powerplant.png");
const _temp59 = require("url:./projector.png");
const _temp60 = require("url:./reflector.png");
const _temp61 = require("url:./residence.png");
const _temp62 = require("url:./road_0.png");
const _temp63 = require("url:./road_1.png");
const _temp64 = require("url:./road_10.png");
const _temp65 = require("url:./road_11.png");
const _temp66 = require("url:./road_12.png");
const _temp67 = require("url:./road_13.png");
const _temp68 = require("url:./road_14.png");
const _temp69 = require("url:./road_15.png");
const _temp70 = require("url:./road_2.png");
const _temp71 = require("url:./road_3.png");
const _temp72 = require("url:./road_4.png");
const _temp73 = require("url:./road_5.png");
const _temp74 = require("url:./road_6.png");
const _temp75 = require("url:./road_7.png");
const _temp76 = require("url:./road_8.png");
const _temp77 = require("url:./road_9.png");
const _temp78 = require("url:./rubble.png");
const _temp79 = require("url:./shield_1.png");
const _temp80 = require("url:./shield_2.png");
const _temp81 = require("url:./shield_3.png");
const _temp82 = require("url:./shield_generator.png");
const _temp83 = require("url:./skull.png");
const _temp84 = require("url:./solarpanel.png");
const _temp85 = require("url:./splitter.png");
const _temp86 = require("url:./splitter_advanced.png");
const _temp87 = require("url:./target.png");
const _temp88 = require("url:./tent.png");
const _temp89 = require("url:./wall.png");
const _temp90 = require("url:./wall_crumbling.png");
const _temp91 = require("url:./wall_damaged.png");
const _temp92 = require("url:./warehouse.png");
const _temp93 = require("url:./water_0.png");
const _temp94 = require("url:./water_15.png");
const _temp95 = require("url:./water_4.png");
const _temp96 = require("url:./water_5.png");
const _temp97 = require("url:./water_6.png");
const _temp98 = require("url:./water_7.png");
const _temp99 = require("url:./water_corner.png");
const _temp100 = require("url:./windmill-1.png");
const _temp101 = require("url:./windmill-2.png");
const _temp102 = require("url:./windmill-3.png");
const _temp103 = require("url:./windmill-4.png");
const _temp104 = require("url:./windows_factory_1.png");
const _temp105 = require("url:./windows_factory_2.png");
const _temp106 = require("url:./windows_mine_1.png");
const _temp107 = require("url:./windows_mine_2.png");
const _temp108 = require("url:./windows_residence_1.png");
const _temp109 = require("url:./windows_residence_2.png");
const _temp110 = require("url:./windows_residence_3.png");
const _temp111 = require("url:./windows_tent_1.png");
const _temp112 = require("url:./windows_warehouse_1.png");
const _temp113 = require("url:./windows_warehouse_2.png");
module.exports = {
  "absorber": _temp0,
  "absorber_charge": _temp1,
  "basic_projector": _temp2,
  "battery": _temp3,
  "blank": _temp4,
  "border": _temp5,
  "colonists1": _temp6,
  "colonists2": _temp7,
  "colonists3": _temp8,
  "cursor_build": _temp9,
  "cursor_cancel": _temp10,
  "cursor_move": _temp11,
  "cursor_reflector": _temp12,
  "direction-indicator": _temp13,
  "disabled": _temp14,
  "enemy_armored_1": _temp15,
  "enemy_armored_2": _temp16,
  "enemy_burrowed_1": _temp17,
  "enemy_burrowed_2": _temp18,
  "enemy_burrower_1": _temp19,
  "enemy_burrower_2": _temp20,
  "enemy_drone_1": _temp21,
  "enemy_drone_2": _temp22,
  "enemy_flyer_1": _temp23,
  "enemy_flyer_2": _temp24,
  "enemy_volatile_1": _temp25,
  "enemy_volatile_2": _temp26,
  "exclamation_double": _temp27,
  "exclamation_single": _temp28,
  "exclamation_triple": _temp29,
  "factory": _temp30,
  "farm": _temp31,
  "farm_growth_1": _temp32,
  "farm_growth_2": _temp33,
  "farm_growth_3": _temp34,
  "fertile": _temp35,
  "floor": _temp36,
  "food": _temp37,
  "laser": _temp38,
  "laser_4split": _temp39,
  "laser_burst": _temp40,
  "laser_player_down": _temp41,
  "laser_player_left": _temp42,
  "laser_player_right": _temp43,
  "laser_player_up": _temp44,
  "laser_reflected": _temp45,
  "laser_split": _temp46,
  "machinery": _temp47,
  "metal": _temp48,
  "mine": _temp49,
  "mining_spot": _temp50,
  "mountain": _temp51,
  "ore": _temp52,
  "outline_dashed": _temp53,
  "outline_exclamation": _temp54,
  "outline_solid": _temp55,
  "player": _temp56,
  "power": _temp57,
  "powerplant": _temp58,
  "projector": _temp59,
  "reflector": _temp60,
  "residence": _temp61,
  "road_0": _temp62,
  "road_1": _temp63,
  "road_10": _temp64,
  "road_11": _temp65,
  "road_12": _temp66,
  "road_13": _temp67,
  "road_14": _temp68,
  "road_15": _temp69,
  "road_2": _temp70,
  "road_3": _temp71,
  "road_4": _temp72,
  "road_5": _temp73,
  "road_6": _temp74,
  "road_7": _temp75,
  "road_8": _temp76,
  "road_9": _temp77,
  "rubble": _temp78,
  "shield_1": _temp79,
  "shield_2": _temp80,
  "shield_3": _temp81,
  "shield_generator": _temp82,
  "skull": _temp83,
  "solarpanel": _temp84,
  "splitter": _temp85,
  "splitter_advanced": _temp86,
  "target": _temp87,
  "tent": _temp88,
  "wall": _temp89,
  "wall_crumbling": _temp90,
  "wall_damaged": _temp91,
  "warehouse": _temp92,
  "water_0": _temp93,
  "water_15": _temp94,
  "water_4": _temp95,
  "water_5": _temp96,
  "water_6": _temp97,
  "water_7": _temp98,
  "water_corner": _temp99,
  "windmill-1": _temp100,
  "windmill-2": _temp101,
  "windmill-3": _temp102,
  "windmill-4": _temp103,
  "windows_factory_1": _temp104,
  "windows_factory_2": _temp105,
  "windows_mine_1": _temp106,
  "windows_mine_2": _temp107,
  "windows_residence_1": _temp108,
  "windows_residence_2": _temp109,
  "windows_residence_3": _temp110,
  "windows_tent_1": _temp111,
  "windows_warehouse_1": _temp112,
  "windows_warehouse_2": _temp113
}